var chunkMapping = {
	"0": [
		4932
	],
	"76": [
		5050
	],
	"151": [
		5125
	],
	"152": [
		5126
	],
	"155": [
		5129
	],
	"156": [
		5130
	],
	"157": [
		5131
	],
	"158": [
		5132
	],
	"159": [
		5133
	],
	"160": [
		5134
	],
	"161": [
		5135
	],
	"162": [
		5136
	],
	"163": [
		5137
	],
	"164": [
		5138
	],
	"165": [
		5139
	],
	"166": [
		5140
	],
	"167": [
		5141
	],
	"168": [
		5142
	],
	"169": [
		5143
	],
	"170": [
		5144
	],
	"171": [
		5145
	]
};
var idToExternalAndNameMapping = {
	"4932": [
		"default",
		"./Containers",
		3803
	],
	"5050": [
		"default",
		"./OrderlessInvoices",
		3803
	],
	"5125": [
		"default",
		"./AsyncEventTracker",
		3803
	],
	"5126": [
		"default",
		"./HostWrapper",
		3803
	],
	"5129": [
		"default",
		"./CheckoutV3",
		3803
	],
	"5130": [
		"default",
		"./CheckoutConfirmation",
		3803
	],
	"5131": [
		"default",
		"./ContactCreditCards",
		3803
	],
	"5132": [
		"default",
		"./AuditDialog",
		3803
	],
	"5133": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3803
	],
	"5134": [
		"default",
		"./InvoiceDialog",
		3803
	],
	"5135": [
		"default",
		"./PaymentDueModal",
		3803
	],
	"5136": [
		"default",
		"./PaymentModal",
		3803
	],
	"5137": [
		"default",
		"./PaymentHistory",
		3803
	],
	"5138": [
		"default",
		"./PaymentConfigurations",
		3803
	],
	"5139": [
		"default",
		"./PaymentPreferences",
		3803
	],
	"5140": [
		"default",
		"./ManagePaymentProcessing",
		3803
	],
	"5141": [
		"default",
		"./MobilePaymentsWrapper",
		3803
	],
	"5142": [
		"default",
		"./Challenge",
		3803
	],
	"5143": [
		"default",
		"./ManagePaymentMethods",
		3803
	],
	"5144": [
		"default",
		"./LightspeedReports",
		3803
	],
	"5145": [
		"default",
		"./ShippingPromotionsListContainer",
		3803
	]
};
var idToRemoteMap = {
	"4932": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5050": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}